__turbopack_context__.v({
  "Root": "_QWVvq_Root",
  "Root--AccordionFade": "_QWVvq_Root--AccordionFade",
  "Root--ArticleBullets": "_QWVvq_Root--ArticleBullets",
  "Root--CandidateAccordion": "_QWVvq_Root--CandidateAccordion",
  "Root--ImageRichText": "_QWVvq_Root--ImageRichText",
  "Root--MediumText": "_QWVvq_Root--MediumText",
  "Root--Small": "_QWVvq_Root--Small",
  "Root--SmallText": "_QWVvq_Root--SmallText",
  "skeleton-loading": "_QWVvq_skeleton-loading",
});
